import { defineStore } from 'pinia';

export const useFileManagerStore = defineStore({
    id: 'filemanager',
    state: () => ({
        currentPath: { dirs:[], key:null }
    }),
    actions: {
    }
});

export default useFileManagerStore